import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as pagesListsActions from "../pagesLists/actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Categories from "./categories";

const feature = "categories";

const InitialState = Record({
  categories: new Categories()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function CategoriesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.categories
    ) {
      state = state.updateIn(["categories", "entities"], map =>
        map.mergeDeep(action.payload.entities.categories));
    }
  }

  switch (action.type) {
    case actions.GET_CATEGORIES: {
      return state.setIn(["categories", "loading"], true);
    }
    case actions.GET_CATEGORIES_SUCCESS: {
      state = state.deleteIn(["categories", "entities"]);
      state = state.deleteIn(["categories", "results"]);
      state = state.setIn(
        ["categories", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["categories", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["categories", "entities"], map =>
        map.mergeDeep(action.payload.entities.categories));
      state = state.setIn(
        ["categories", "results"],
        action.payload.result.categories
      );
      return state.setIn(["categories", "loading"], false);
    }
    case actions.GET_CATEGORIES_ERROR: {
      return state.setIn(["categories", "loading"], false);
    }

    case actions.PATCH_CATEGORY: {
      return state.setIn(["categories", "loading"], true);
    }
    case actions.PATCH_CATEGORY_SUCCESS: {
      return state.setIn(["categories", "loading"], false);
    }
    case actions.PATCH_CATEGORY_ERROR: {
      return state.setIn(["categories", "loading"], false);
    }

    case actions.DELETE_CATEGORY: {
      return state.deleteIn(["categories", "entities", action.payload.uid]);
    }

    case actions.SET_IS_REMOVE_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["categories", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }
    case actions.SET_IS_EDIT_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["categories", "isEditModalVisible"],
        action.payload.isVisible
      );
    }

  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/categories/reducer.js